import { render } from "./HeroView.vue?vue&type=template&id=57a3417e"
import script from "./HeroView.vue?vue&type=script&lang=js"
export * from "./HeroView.vue?vue&type=script&lang=js"

import "./HeroView.vue?vue&type=style&index=0&id=57a3417e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__